import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const sections = [
    { id: 'about', number: '1', title: 'About Healthy Home', icon: 'ph-leaf' },
    { id: 'product-info', number: '2', title: 'Product Information', icon: 'ph-package' },
    { id: 'pricing-taxes', number: '3', title: 'Pricing and Taxes', icon: 'ph-currency-inr' },
    { id: 'orders', number: '4', title: 'Orders & Acceptance', icon: 'ph-shopping-bag-open' },
    { id: 'payments', number: '5', title: 'Payments & Security', icon: 'ph-credit-card' },
    { id: 'shipping-delivery', number: '6', title: 'Shipping and Delivery', icon: 'ph-truck' },
    { id: 'cancellation-refunds', number: '7', title: 'Cancellation, Returns & Refunds', icon: 'ph-arrow-counter-clockwise' },
    { id: 'storage-usage', number: '8', title: 'Product Storage and Usage', icon: 'ph-thermometer-cold' },
    { id: 'intellectual-property', number: '9', title: 'Intellectual Property', icon: 'ph-shield-check' },
    { id: 'website-use', number: '10', title: 'Website Use & Prohibited Acts', icon: 'ph-globe' },
    { id: 'third-party', number: '11', title: 'Third-Party Services', icon: 'ph-handshake' },
    { id: 'limitation-liability', number: '12', title: 'Limitation of Liability', icon: 'ph-scales' },
    { id: 'changes-terms', number: '13', title: 'Changes to These Terms', icon: 'ph-pencil-simple-line' },
    { id: 'governing-law', number: '14', title: 'Governing Law & Jurisdiction', icon: 'ph-gavel' },
    { id: 'contact-us', number: '15', title: 'Contact Us', icon: 'ph-envelope-open' },
];

const TermsConditions = () => {
    const [activeSection, setActiveSection] = useState('about');

    const scrollToSection = (id) => {
        setActiveSection(id);
        const element = document.getElementById(id);
        if (element) {
            const yOffset = -100;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <section className="terms-section py-80 bg-gray-50 position-relative">
            <style>{`
                .terms-card {
                    background: #ffffff;
                    border: 1px solid #EFEFEF;
                    border-radius: 16px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.03);
                    transition: all 0.3s ease;
                }
                .terms-card:hover {
                    box-shadow: 0 8px 30px rgba(0,0,0,0.06);
                }
                .terms-sidebar {
                    position: sticky;
                    top: 100px;
                    background: #ffffff;
                    border: 1px solid #EFEFEF;
                    border-radius: 16px;
                    padding: 24px 16px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.03);
                    max-height: calc(100vh - 120px);
                    overflow-y: auto;
                }
                .terms-nav-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 14px;
                    border-radius: 8px;
                    font-size: 14px;
                    font-weight: 500;
                    color: #4A5568;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    border: none;
                    background: transparent;
                    width: 100%;
                    text-align: left;
                }
                .terms-nav-item:hover {
                    background: #F4FAF5;
                    color: var(--main-600, #2FA84F);
                }
                .terms-nav-item.active {
                    background: #EAF8EE;
                    color: var(--main-600, #2FA84F);
                    font-weight: 600;
                }
                .terms-icon-box {
                    width: 44px;
                    height: 44px;
                    border-radius: 12px;
                    background: #EAF8EE;
                    color: var(--main-600, #2FA84F);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    flex-shrink: 0;
                }
                .policy-notice-box {
                    background: #F8FDF9;
                    border-left: 4px solid var(--main-600, #2FA84F);
                    padding: 16px 20px;
                    border-radius: 0 12px 12px 0;
                    margin: 16px 0;
                }
                .policy-warning-box {
                    background: #FFFDF5;
                    border-left: 4px solid #F59E0B;
                    padding: 16px 20px;
                    border-radius: 0 12px 12px 0;
                    margin: 16px 0;
                }
                .policy-list {
                    padding-left: 0;
                    list-style: none;
                    margin-bottom: 0;
                }
                .policy-list li {
                    position: relative;
                    padding-left: 28px;
                    margin-bottom: 12px;
                    color: #4A5568;
                    line-height: 1.65;
                }
                .policy-list li::before {
                    content: '✓';
                    position: absolute;
                    left: 0;
                    top: 0;
                    color: var(--main-600, #2FA84F);
                    font-weight: bold;
                }
                .policy-bullet-list {
                    padding-left: 20px;
                    margin-bottom: 16px;
                }
                .policy-bullet-list li {
                    margin-bottom: 8px;
                    color: #4A5568;
                    line-height: 1.65;
                }
            `}</style>

            <div className="container container-lg">
                {/* Header Banner */}
                <div className="text-center mb-48 wow fadeInUp" data-wow-duration="0.6s">
                    <span className="text-main-600 fw-semibold text-uppercase mb-12 d-inline-block px-16 py-6 rounded-pill bg-main-50" style={{ letterSpacing: '1px', fontSize: 13 }}>
                        Legal &amp; Compliance
                    </span>
                    <h2 className="fw-bold mb-16">Terms &amp; Conditions</h2>
                    <p className="text-gray-600 max-w-700 mx-auto" style={{ fontSize: 16, lineHeight: 1.7 }}>
                        Welcome to Healthy Home. These Terms &amp; Conditions govern your use of our website <strong className="text-main-600">healthyhomeonline.in</strong> and the purchase of products through our website. By accessing our website or placing an order, you agree to these Terms &amp; Conditions.
                    </p>
                </div>

                <div className="row g-4">
                    {/* Sticky Sidebar (TOC) */}
                    <div className="col-lg-4 d-none d-lg-block">
                        <div className="terms-sidebar">
                            <h6 className="fw-bold mb-16 px-12 text-gray-900 flex-align gap-8">
                                <i className="ph ph-list-numbers text-main-600 text-lg" /> Table of Contents
                            </h6>
                            <div className="d-flex flex-column gap-4">
                                {sections.map((sec) => (
                                    <button
                                        key={sec.id}
                                        onClick={() => scrollToSection(sec.id)}
                                        className={`terms-nav-item ${activeSection === sec.id ? 'active' : ''}`}
                                    >
                                        <i className={`ph ${sec.icon} text-md`} />
                                        <span className="text-truncate">{sec.number}. {sec.title}</span>
                                    </button>
                                ))}
                            </div>

                            <div className="mt-24 pt-20 border-top border-gray-100 px-12 text-center">
                                <span className="text-xs text-gray-500 d-block mb-8">Need clarification?</span>
                                <Link to="/contact" className="btn btn-outline-main btn-sm rounded-pill w-100 py-8">
                                    <i className="ph ph-chat-circle-dots me-6" /> Contact Support
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-lg-8">
                        <div className="d-flex flex-column gap-32">

                            {/* Preamble / Welcome Box */}
                            <div className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-info" />
                                    </div>
                                    <div>
                                        <h4 className="fw-bold mb-4">Welcome to Healthy Home</h4>
                                        <span className="text-sm text-gray-500">Official Terms of Service for healthyhomeonline.in</span>
                                    </div>
                                </div>
                                <div className="policy-notice-box">
                                    <p className="mb-0 text-gray-700 fw-medium" style={{ lineHeight: 1.7 }}>
                                        These Terms &amp; Conditions govern your use of our website <strong>healthyhomeonline.in</strong> and the purchase of products through our website. By accessing our website or placing an order, you agree to be bound by these Terms &amp; Conditions.
                                    </p>
                                </div>
                            </div>

                            {/* Section 1: About Healthy Home */}
                            <div id="about" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-leaf" />
                                    </div>
                                    <h4 className="fw-bold mb-0">1. About Healthy Home</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Healthy Home offers food products including cold-pressed edible oils, traditional sweeteners, rock salts, and other related pure, natural products.
                                </p>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    The product information, pricing, availability, packaging, and offers displayed on the website may be updated from time to time without prior notice.
                                </p>
                            </div>

                            {/* Section 2: Product Information */}
                            <div id="product-info" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-package" />
                                    </div>
                                    <h4 className="fw-bold mb-0">2. Product Information</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    We make reasonable efforts to ensure that product descriptions, images, prices, quantities, and other information displayed on our website are accurate and up to date.
                                </p>
                                <ul className="policy-list mb-20">
                                    <li>
                                        <strong>Packaging &amp; Appearance:</strong> Actual product packaging, label design, or colour may vary slightly from images displayed on the website without affecting the nature, purity, or quality of the product.
                                    </li>
                                    <li>
                                        <strong>Customer Due Diligence:</strong> Customers should carefully read the product label, ingredients, storage instructions, manufacturing details, expiry / best-before information, and any allergen warnings before use.
                                    </li>
                                </ul>
                            </div>

                            {/* Section 3: Pricing and Taxes */}
                            <div id="pricing-taxes" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-currency-inr" />
                                    </div>
                                    <h4 className="fw-bold mb-0">3. Pricing and Taxes</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    All prices displayed on the website are in Indian Rupees (₹).
                                </p>
                                <ul className="policy-list mb-16">
                                    <li>
                                        <strong>Taxes Included:</strong> Unless otherwise stated, prices displayed to customers are inclusive of applicable taxes (GST).
                                    </li>
                                    <li>
                                        <strong>Delivery Charges:</strong> Delivery or shipping charges, if applicable, will be clearly shown at checkout before your order is confirmed.
                                    </li>
                                    <li>
                                        <strong>Price Changes:</strong> We reserve the right to change product prices, discounts, and promotional offers at any time. Price changes will not normally affect orders that have already been successfully confirmed.
                                    </li>
                                </ul>
                            </div>

                            {/* Section 4: Orders */}
                            <div id="orders" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-shopping-bag-open" />
                                    </div>
                                    <h4 className="fw-bold mb-0">4. Orders</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    An order is considered accepted after successful order confirmation. We reserve the right to cancel or refuse an order in circumstances including:
                                </p>
                                <ul className="policy-bullet-list">
                                    <li>Product unavailability or unforeseen stock constraints</li>
                                    <li>Incorrect pricing or inaccurate product information displayed in error</li>
                                    <li>Payment failure or incomplete transaction authentication</li>
                                    <li>Suspected fraudulent or unauthorized transactions</li>
                                    <li>Incorrect, incomplete, or unserviceable delivery information</li>
                                    <li>Delivery restrictions or circumstances beyond our reasonable control (force majeure)</li>
                                </ul>
                                <div className="policy-notice-box">
                                    <p className="mb-0 text-gray-800 text-sm">
                                        <strong>Prepaid Order Refund:</strong> If a prepaid order is cancelled by Healthy Home, the eligible amount paid will be refunded back through the applicable original payment method in accordance with our standard refund timelines.
                                    </p>
                                </div>
                            </div>

                            {/* Section 5: Payments */}
                            <div id="payments" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-credit-card" />
                                    </div>
                                    <h4 className="fw-bold mb-0">5. Payments</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Customers may use the payment methods made available on our website (including UPI, Debit Cards, Credit Cards, Net Banking, and other authorized modes).
                                </p>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Online payments may be securely processed through authorized third-party payment gateway providers (such as Razorpay).
                                </p>
                                <div className="policy-notice-box">
                                    <p className="mb-0 text-gray-800 text-sm">
                                        <strong>Security Commitment:</strong> Healthy Home does not directly store complete debit card, credit card, CVV, or other sensitive payment authentication information where the payment is processed by an authorised third-party payment provider.
                                    </p>
                                </div>
                            </div>

                            {/* Section 6: Shipping and Delivery */}
                            <div id="shipping-delivery" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-truck" />
                                    </div>
                                    <h4 className="fw-bold mb-0">6. Shipping and Delivery</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Orders will be shipped to the delivery address provided by the customer at checkout.
                                </p>
                                <ul className="policy-list mb-16">
                                    <li>
                                        <strong>Delivery Timelines:</strong> Estimated delivery times are indicative and may vary depending on the delivery location, courier service efficiency, public holidays, weather conditions, operational disruptions, and other circumstances beyond our reasonable control.
                                    </li>
                                    <li>
                                        <strong>Accurate Information:</strong> Customers are responsible for providing a complete, accurate delivery address with appropriate landmarks and a reachable contact number.
                                    </li>
                                    <li>
                                        <strong>Detailed Policy:</strong> Detailed delivery terms, where applicable, are provided in our Shipping &amp; Delivery Policy.
                                    </li>
                                </ul>
                            </div>

                            {/* Section 7: Cancellation, Returns and Refunds */}
                            <div id="cancellation-refunds" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-arrow-counter-clockwise" />
                                    </div>
                                    <h4 className="fw-bold mb-0">7. Cancellation, Returns and Refunds</h4>
                                </div>
                                <div className="policy-warning-box mb-20">
                                    <p className="mb-0 text-gray-800 fw-medium text-sm">
                                        <strong>Food Safety &amp; Hygiene Notice:</strong> Because we sell food and edible products, returns may be restricted for strict reasons of food safety, health, and hygiene.
                                    </p>
                                </div>
                                <p className="text-gray-700 mb-12" style={{ lineHeight: 1.8 }}>
                                    Customers should contact us promptly upon receipt of their order if they receive:
                                </p>
                                <ul className="policy-bullet-list">
                                    <li>A damaged or leaking product</li>
                                    <li>An incorrect product or variant</li>
                                    <li>A product materially different from the order placed</li>
                                </ul>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    Eligibility for cancellation, return, or refund will be governed by our Cancellation, Return &amp; Refund Policy. We may request clear photographs, unboxing videos, packaging details, or other reasonable evidence before approving a return or refund.
                                </p>
                            </div>

                            {/* Section 8: Product Storage and Usage */}
                            <div id="storage-usage" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-thermometer-cold" />
                                    </div>
                                    <h4 className="fw-bold mb-0">8. Product Storage and Usage</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    Customers should follow the storage and usage instructions mentioned on the product label (such as keeping cold-pressed oils in cool, dry places away from direct sunlight).
                                </p>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    Healthy Home will not be responsible for product deterioration, spoilage, or quality loss caused by improper storage, handling, or use after delivery.
                                </p>
                            </div>

                            {/* Section 9: Intellectual Property */}
                            <div id="intellectual-property" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-shield-check" />
                                    </div>
                                    <h4 className="fw-bold mb-0">9. Intellectual Property</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    The <strong>Healthy Home</strong> brand name, logo, website content, product photographs, graphics, label designs, and other brand materials displayed on this website are owned by, licensed to, or used with permission by Healthy Home, as applicable.
                                </p>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    They may not be copied, reproduced, modified, distributed, or commercially used without prior written permission from Healthy Home.
                                </p>
                            </div>

                            {/* Section 10: Website Use */}
                            <div id="website-use" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-globe" />
                                    </div>
                                    <h4 className="fw-bold mb-0">10. Website Use</h4>
                                </div>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    You agree not to misuse the website, interfere with its proper operation, attempt unauthorised access to our systems or user accounts, introduce malicious software or viruses, or use the website for any unlawful, misleading, or fraudulent activities.
                                </p>
                            </div>

                            {/* Section 11: Third-Party Services */}
                            <div id="third-party" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-handshake" />
                                    </div>
                                    <h4 className="fw-bold mb-0">11. Third-Party Services</h4>
                                </div>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    Our website may use third-party services for payment processing, logistics and shipment tracking, analytics, communications, or other business functions. Use of such services may also be subject to the respective service provider&apos;s terms and privacy policies.
                                </p>
                            </div>

                            {/* Section 12: Limitation of Liability */}
                            <div id="limitation-liability" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-scales" />
                                    </div>
                                    <h4 className="fw-bold mb-0">12. Limitation of Liability</h4>
                                </div>
                                <p className="text-gray-700 mb-16" style={{ lineHeight: 1.8 }}>
                                    To the extent permitted by applicable law, Healthy Home will not be responsible for indirect, incidental, or consequential losses arising from misuse of products, incorrect information supplied by customers, third-party service interruptions, or events outside our reasonable control.
                                </p>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    Nothing in these Terms &amp; Conditions excludes or restricts any rights or remedies available to consumers that cannot lawfully be excluded under applicable Indian laws.
                                </p>
                            </div>

                            {/* Section 13: Changes to These Terms */}
                            <div id="changes-terms" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-pencil-simple-line" />
                                    </div>
                                    <h4 className="fw-bold mb-0">13. Changes to These Terms</h4>
                                </div>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    Healthy Home may update these Terms &amp; Conditions from time to time when necessary. The latest version will be published on this website along with the updated date. Your continued use of the website following any changes signifies your acceptance of the updated terms.
                                </p>
                            </div>

                            {/* Section 14: Governing Law */}
                            <div id="governing-law" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s">
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box">
                                        <i className="ph ph-gavel" />
                                    </div>
                                    <h4 className="fw-bold mb-0">14. Governing Law</h4>
                                </div>
                                <p className="text-gray-700 mb-0" style={{ lineHeight: 1.8 }}>
                                    These Terms &amp; Conditions are governed by and construed in accordance with the applicable laws of India. Any dispute arising out of or in connection with these Terms shall be subject to applicable consumer protection laws and the jurisdiction of competent courts in Bengaluru, Karnataka, India.
                                </p>
                            </div>

                            {/* Section 15: Contact Us */}
                            <div id="contact-us" className="terms-card p-32 wow fadeInUp" data-wow-duration="0.5s" style={{ background: 'linear-gradient(135deg, #F8FDF9 0%, #FFFFFF 100%)', border: '1px solid #CDE8D5' }}>
                                <div className="d-flex align-items-center gap-16 mb-20">
                                    <div className="terms-icon-box" style={{ background: 'var(--main-600, #2FA84F)', color: '#FFFFFF' }}>
                                        <i className="ph ph-envelope-open" />
                                    </div>
                                    <div>
                                        <h4 className="fw-bold mb-4">15. Contact Us</h4>
                                        <span className="text-sm text-gray-600">Have questions about these Terms &amp; Conditions or your order?</span>
                                    </div>
                                </div>

                                <div className="row g-3 mt-12">
                                    <div className="col-md-6">
                                        <div className="p-20 bg-white rounded-12 border border-gray-100 h-100">
                                            <div className="d-flex align-items-center gap-12 mb-8">
                                                <span className="w-36 h-36 flex-center rounded-circle bg-main-50 text-main-600">
                                                    <i className="ph ph-buildings text-lg" />
                                                </span>
                                                <strong className="text-gray-900">Brand Name</strong>
                                            </div>
                                            <p className="text-gray-700 mb-0 ps-48">Healthy Home</p>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="p-20 bg-white rounded-12 border border-gray-100 h-100">
                                            <div className="d-flex align-items-center gap-12 mb-8">
                                                <span className="w-36 h-36 flex-center rounded-circle bg-main-50 text-main-600">
                                                    <i className="ph ph-globe text-lg" />
                                                </span>
                                                <strong className="text-gray-900">Website</strong>
                                            </div>
                                            <p className="text-gray-700 mb-0 ps-48">
                                                <a href="https://healthyhomeonline.in" target="_blank" rel="noopener noreferrer" className="text-main-600 hover-text-decoration-underline">
                                                    healthyhomeonline.in
                                                </a>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="p-20 bg-white rounded-12 border border-gray-100 h-100">
                                            <div className="d-flex align-items-center gap-12 mb-8">
                                                <span className="w-36 h-36 flex-center rounded-circle bg-main-50 text-main-600">
                                                    <i className="ph ph-phone-call text-lg" />
                                                </span>
                                                <strong className="text-gray-900">Phone Support</strong>
                                            </div>
                                            <p className="text-gray-700 mb-0 ps-48">
                                                <a href="tel:9449818329" className="text-main-600 hover-text-decoration-underline">
                                                    +91 9449818329
                                                </a>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="p-20 bg-white rounded-12 border border-gray-100 h-100">
                                            <div className="d-flex align-items-center gap-12 mb-8">
                                                <span className="w-36 h-36 flex-center rounded-circle bg-main-50 text-main-600">
                                                    <i className="ph ph-map-pin text-lg" />
                                                </span>
                                                <strong className="text-gray-900">Location</strong>
                                            </div>
                                            <p className="text-gray-700 mb-0 ps-48">
                                                Bengaluru, Karnataka, India
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TermsConditions;
